import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  ToggleButton,
  ToggleButtonGroup,
  Form,
} from "react-bootstrap";
import _ from "lodash";
import { useLazyQuery, useMutation } from "@apollo/client";

import { GET_PROGRAM_BY_ID_AND_LANG } from "../../schemas/program";
import { ADD_FAVORITE } from "../../schemas/favorite";
import { GlobalState } from "contexts/GlobalState";
import { Notes } from "components/Notes";
import { ReactRegisterModal } from "../RegisterForm/components/ReactRegisterModal";
import { FavoriteButton } from "components/FavoriteButton";
import "./style.scss";

export const AddToFavorite = ({
  labels,
  item,
  getAllFavorites,
  registerFormLabels,
  fromProgramPage
}) => {
  // addedData values: "added" if added to favorites button worked well, "err" if there was an error
  const [addedData, setAddedData] = useState("");
  const [show, setShow] = useState(false);
  const [getProgramByIdAndLang, { loading, data, error }] = useLazyQuery(GET_PROGRAM_BY_ID_AND_LANG);
  const [program, setProgram] = useState({});
  const [toggleButtons, setToggleButtons] = useState();
  const [options, setOptions] = useState();
  const [selectedTrackIndex, setSelectedTrackIndex] = useState(0);
  const [selectedTrack, setSelectedTrack] = useState("");
  const [selectedTrackId, setSelectedTrackId] = useState("");
  const [programName, setProgramName] = useState("");
  const [addFavorite, { data: dataFavorite, error: errorFavorite }] = useMutation(ADD_FAVORITE, {});
  const [globalUser, setGlobalUser] = GlobalState("user");
  const [notes, setNotes] = useState("");
  const [showRegister, setShowRegister] = useState(false);

  const openModal = (event) => {
    if (globalUser.user) {
      getProgramByIdAndLang({
        variables: {
          nid: Number(item.nid),
          langcode: labels.lang ?? item.langcode,
        },
      });
      setShow(true);
    } else {
      setShowRegister(true);
      setProgramName(item?.title);
    }
  };

  const handleChange = (e, titles) => {
    e.preventDefault();
    e.stopPropagation();
    setOptions(titles);
  };
  const handleClickAddToFavBtn = () => {
    if (addedData !== "added") {
      addFavorite({
        variables: {
          programInfo: {
            nid: item.nid,
            weight: 0,
            langcode: item.langcode,
            notes: notes,
            track: selectedTrack ?? "",
            trackId: selectedTrackId
          }
        }
      });
    }
    if(globalUser.user)
    {
      JsonforSalesforce();
    }
  };

  const hideModal = (e) => {
    setShow(false);
    getAllFavorites();
  };
  useEffect(() => {
    if (dataFavorite) {
      setAddedData("added");
    }
    if (errorFavorite) {
      setAddedData("err");
      console.log(errorFavorite);
    }
  }, [dataFavorite, errorFavorite]);

  useEffect(() => {
    if (!loading && data?.getProgramByIdAndLang) {
      setProgram({ ...data.getProgramByIdAndLang });
      if (!_.isEmpty(data.getProgramByIdAndLang.field_mamta_programs)) {
        const newOutput = _(data.getProgramByIdAndLang.field_mamta_programs)
          .groupBy("field_learning_aspect_name")
          .map((v, k) => ({
            field_learning_aspect_name: k,
            titles: _.map(v, "title"),
          }))
          .value();
        setToggleButtons(newOutput);
        setOptions(newOutput[0].titles);
      }
    }
    if (error) {
      console.log(error);
    }
  }, [loading, data, error]);

  useEffect(() => {
    if (selectedTrackIndex !== 0) {
      setSelectedTrackIndex(0);
    } else {
      setSelectedTrack(options?.[0]);
    }
  }, [options])

  useEffect(() => {
    setSelectedTrack(options?.[selectedTrackIndex]);
  }, [selectedTrackIndex])

  useEffect(() => {
    if (data?.getProgramByIdAndLang?.field_mamta_programs) {
      for (let track of data?.getProgramByIdAndLang?.field_mamta_programs) {
        if (track.title === selectedTrack) {
          setSelectedTrackId(track.field_plain_id);
          break;
        }
      }
    }
  }, [selectedTrack])

  async function JsonforSalesforce() {
    const postBody = {
      tfa_33: globalUser?.user?.fullName||"",
      tfa_37: `אתר ההרשמה אזור אישי- ${program?.field_bi_degree_description}-${program?.field_bi_faculty_description}-${program?.field_bi_interested_description}`,
      tfa_36: globalUser?.user?.phone||"",
      tfa_35: globalUser?.user?.email||"",
      tfa_62: program?.field_bi_degree_number||"",
      tfa_41: program?.field_bi_degree_description||"",
      tfa_63: program?.field_bi_faculty_number||"",
      tfa_47: program?.field_bi_faculty_description||"",
      tfa_64: program?.field_bi_interested_number||"",
      tfa_38: program?.field_bi_interested_description||"",
      tfa_34: "",
      tfa_39: "",
      tfa_43: "",
      tfa_44: "",
      tfa_45: !Utils.isMobile() ?"tfa_46":"tfa_67",
      tfa_48: "",
      tfa_49: "",
      tfa_51: "",
      tfa_52: globalUser?.user?.checkbox=="true"?"tfa_56":"tfa_57",
      tfa_60: "",
      tfa_61: "7014G000001uWO0",
      tfa_69: globalUser?.user?.maturity||"",
      tfa_70: globalUser?.user?.psychometric||"",
      tfa_72: globalUser?.user?.adapter||"",
      tfa_dbFormId: '4808324', 
      tfa_dbResponseId: '',
      tfa_dbControl: '185ce51c138eb3c98621e85cf7a6618a',
      tfa_dbVersionId: '2',
      tfa_switchedoff: ''
    };
    const requestMetadata = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(postBody)
    };
    const response = await fetch(`${window.location.origin}/salesForce/sendSalesForce?url=api_v2/workflow/processor`, requestMetadata);
    return false;
  };

  return (
    <div className="add-to-favorite">
      <Row>
        <FavoriteButton
          addButton={true}
          fromProgramPage={fromProgramPage}
          handleClick={openModal}
          labels={labels}
        />
      </Row>
      <Modal
        show={show}
        onHide={() => hideModal()}
        //need to check if aria-label is working
        aria-label={labels.popupTitle}
        className="add-to-favorite-popup"
      >
        <Modal.Header className="custom-modal-head">
          <Button tabIndex="0" aria-label={labels.closePopup} className="close" onClick={() => hideModal()} />
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={1} className="circle-wrapper">
              <div className="circle"></div>
            </Col>
            <Col className="body-content">
              {/* div from start to dirst black line */}
              <div className="first-part-wrapper">
                <h3 tabIndex="0" className="chose-to-add">{labels.chose_to_add}</h3>
                <h1 tabIndex="0" className="subject">{program.title}</h1>
              </div>
              {/* A row for putting notes and matkonet side by side */}
              <Row className="main-section">
                <Col sm={12} md={5} className="px-0">
                  {/*div from first black line to first grey line */}
                  <div className="second-part-wrapper">
                    <h3 tabIndex="0" className="format">{labels.format}</h3>
                    <ToggleButtonGroup
                      type="radio"
                      name="options"
                      defaultValue={0}
                    >
                      {toggleButtons &&
                        toggleButtons.map((element, index) => (
                          <ToggleButton
                            key={element.field_learning_aspect_name}
                            variant="light"
                            className="num-of-majors-btn"
                            value={index}
                            onChange={(e) => handleChange(e, element.titles)}
                            id={`numOfMajBtn${index}`}
                            aria-labelledby={`numOfMajBtn${index}`}
                            tabIndex="0"
                          >
                            {element.field_learning_aspect_name}
                          </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                    <h3 tabIndex="0" className="track">{labels.track}</h3>
                    {/* dropdown for mobile  */}
                    {Utils.isMobile() ? (
                      <Form
                      >
                        <Form.Group controlId="trackForm" >
                          <Form.Control as="select" value={selectedTrack} onChange={(e) => setSelectedTrack(e.target.value)}
                          >
                            {options &&
                              options.map((element, index) => (
                                <option key={element}>{element}</option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </Form>
                    ) : (
                      /* radio buttons for desktop */
                      <ToggleButtonGroup
                        type="radio"
                        name="options"
                        vertical="true"
                        value={selectedTrackIndex}
                        onChange={(index) => setSelectedTrackIndex(index)}
                      >
                        {options &&
                          options.map((element, index) => (
                            <ToggleButton variant="link" value={index} key={element} id={`trackOption${index}`}>
                              <div className="radio-circle" />
                              <span>{element}</span>
                            </ToggleButton>
                          ))}
                      </ToggleButtonGroup>
                    )}
                  </div>
                  <div
                    className="attention-text"
                    dangerouslySetInnerHTML={{
                      __html: program.field_comments,
                    }}
                  ></div>
                </Col>
                <Col sm={12} md={7} className="body-row-sec-col px-0">
                  <Notes
                    item={program}
                    defaultNotes=""
                    setAddToFavNotes={setNotes}
                    parentWidget="parent-is-add-to-favorite"
                    labels={labels}
                  />
                </Col>
              </Row>
              {/*add button */}
              <Button aria-label={labels.add_to_fav} className="add-button" onClick={handleClickAddToFavBtn}>
                <div className="heart-img" />
                <p>{labels.add_to_fav}</p>
              </Button>
              {addedData === "added" && (
                <p tabIndex="0" role="alert" className="added">
                  {labels.added}
                </p>
              )}
              {addedData === "err" && (
                <p tabIndex="0" role="alert" className="error">
                  {labels.error_msg}
                </p>
              )}
              {addedData !== "" && (
                <>
                  <Row>
                    <Button
                      aria-label={labels.back_to_home}
                      className="redirect-btn"
                      variant="link"
                      href={labels.home_url}
                    >
                      {labels.back_to_home}
                      <div className="left-arrow-img" />
                    </Button>
                  </Row>
                  <Row>
                    <Button
                      aria-label={labels.to_your_fav}
                      className="redirect-btn"
                      variant="link"
                      href={labels.profile_url}
                    >
                      {labels.to_your_fav}
                      <div className="left-arrow-img" />
                    </Button>
                  </Row>
                </>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <ReactRegisterModal
        programName={programName}
        show={showRegister}
        setShow={setShowRegister}
        labels={registerFormLabels}
        lastAction={{
          action: handleClickAddToFavBtn
        }}
      />
    </div>
  );
};
   